document.addEventListener("DOMContentLoaded", function(){

    let form = document.getElementById('contactusForm');
    form.addEventListener('submit',function(evt){
        evt.preventDefault();

        let partner = document.getElementById('partner_slug').value;
        let formData = new FormData(form);

        sendRequest('POST', '/api/contact-us',formData,function(err,data){
            if(err){
                let error = JSON.parse(err);
                console.log(error);
                let err_str = '';
                if(typeof(error.message) == 'object'){
                    for (const [key, value] of Object.entries(error.message)){
                        err_str += value + '<br>';
                    }
                }else{
                    err_str = error.message;
                }
                console.log(err_str);
                document.getElementById('error_block').innerHTML = err_str;
                document.getElementById('error_block').style.display = '';
                location.href = '#error_block';
            }else{
                let response_data = JSON.parse(data);
                if(response_data.success) {
                    // Show thank you text
                    $('#thankyou').removeClass('d-none');
                    $('#contactusForm').addClass('d-none');
                }
            }
        });

    });

    function sendRequest(method, url, data, done){
        var request = new XMLHttpRequest();
        request.open(method,url);
        request.onload = function () {
            if(request.status == 200){
                done(null, request.response);
            }else{
                done(request.response);
            }
        };
        request.onerror = function () {
            done(request.response);
        };
        request.send(data);
    }
});
